// import { Link } from "gatsby"
import Alink from "../../Alink"
import React from "react"
import styled from "styled-components"
import colors from "../../../../styles/colors"
import fonts from "../../../../styles/fonts"

const StyledLink = styled(Alink)`
  ${fonts.ivyStyleLight};
  width: 100%;
  text-decoration: none;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${colors.black};
  line-height: 1.16;
  padding: 12.5px 30px;
  text-align: left;
  display: inline-block;
  border-bottom: 1px solid #CCC;
  
  text-transform: lowercase;
  &:first-of-type {
    margin-top: 5px;
    background: ${colors.newbeige};
  }
`

const StyledButton = styled.button`
  ${fonts.ivyStyleLight};
  padding: 0;
  border: none;
  background: #f4efed;
  width: 100%;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${(props) => (props.featured ? colors.lightGreen : colors.black)};
  line-height: 1.16;
  padding: 12px 30px;
  text-align: left;
  text-transform: lowercase;
`

const StyledA = styled.a`
  ${fonts.ivyStyleLight};
  width: 100%;
  text-decoration: none;
  color: inherit;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${colors.black};
  line-height: 1.16;
  padding: 12.5px 30px;
  text-align: left;
  display: inline-block;
  border-bottom: 1px solid #CCC;

  text-transform: lowercase;

  &:first-of-type {
    margin-top: 5px;
    background: ${colors.newbeige};
  }
`

const SingleLink = ({ link, handleBespokeFormPopup, closeIfActive }) => {
  if (link.openBespokeForm) {
    return (
      <StyledButton
        onClick={handleBespokeFormPopup}
        featured={link.isFeatured ? 1 : 0}
      >
        {link.title}
      </StyledButton>
    )
  }

  if (link.externalLink) {
    return (
      <StyledA
        href={link.externalLink}
        featured={link.isFeatured ? 1 : 0}
      >
        {link.title}
      </StyledA>
    )
  }

  return (
    <StyledLink
      to={link.link}
      featured={link.isFeatured ? 1 : 0}
      onClick={(e) => closeIfActive(e)}
      prefetch={false}
    >
      {link.title}
    </StyledLink>
  )
}

export default SingleLink
